import { render, staticRenderFns } from "./MemberComponent.vue?vue&type=template&id=622429ff&scoped=true&"
import script from "./MemberComponent.vue?vue&type=script&lang=js&"
export * from "./MemberComponent.vue?vue&type=script&lang=js&"
import style0 from "./MemberComponent.vue?vue&type=style&index=0&id=622429ff&prod&lang=scss&"
import style1 from "./MemberComponent.vue?vue&type=style&index=1&id=622429ff&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622429ff",
  null
  
)

export default component.exports